module.exports = __webpack_public_path__ + "img/visa.e4d35e76.png";